export const addPreventScrollStyle = () => {
    document.body.style.overflow = 'hidden';
}

export const removePreventScrollStyle = () => {
    document.body.style.overflow = 'auto';
}


// WEBPACK FOOTER //
// ./src/utils/preventScroll.js